export default __webpack_public_path__ + "624d94a449633f1fa4f949bcffc09016.svg";